import Link from 'next/link';
import { Layout, CtaForm } from '../../components';

import 'react-medium-image-zoom/dist/styles.css';

export default function WhiteLabelling() {
	return (
		<Layout pageName="White Labelling">
			<div className="resource-page resource-page--white-labelling">
				<section className="heading">
					<div className="container">
						<h1 className="heading__title">White Labelling</h1>
						<div className="heading__content">
							<h2 className="heading__desc">
								You can replace the FacilityBot brand in specific locations with your brand
							</h2>
						</div>
					</div>
				</section>

				<section className="building-type__articles">
					<div className="container">
						<div className="building-type__articles-wrapper">
							<article className="building-type__article">
								<div className="building-type__article-content article">
									<div>
										<h3 className="building-type__article-title article__title">
											Replace FacilityBot image and logo with your image and logo in Sign-In Screen
										</h3>
										<div className="building-type__article-desc article__desc">
											Using the{' '}
											<a href="/features/tenant-portal" target="_blank" rel="noreferrer">
												FacilityBot Tenant Portal feature
											</a>
											, clients can change the image on the Left-Hand Side of the FacilityBot Sign-In page to your logo.
										</div>
									</div>

									<div>
										<h3 className="building-type__article-title article__title">
											Provide a subdomain for your web portals
										</h3>
										<div className="building-type__article-desc article__desc">
											Using the{' '}
											<a href="/features/tenant-portal" target="_blank" rel="noreferrer">
												FacilityBot Tenant Portal feature
											</a>
											, clients can change the subdomain of the FacilityBot Sign-In page to include your company name.
										</div>
										<div className="description__format">[YourCompanyName.facilitybot.co]</div>
									</div>

									<div>
										<h3 className="building-type__article-title article__title">
											Messaging Channels can be configured to show your brand
										</h3>
										<div className="building-type__article-desc article__desc">
											FacilityBot supports many popular messaging channels for Requestors and Tenants to interact with
											FacilityBot. All messaging channels can be configured to use your brand name and your logo.
											Therefore, Requestors and Tenants who use the messaging channels may not know that your Facilities
											Management system is powered by FacilityBot.
										</div>
									</div>
								</div>

								<img src={`/images/white-labelling.webp`} alt="" className="white-labelling-image" />
							</article>
						</div>
					</div>
				</section>

				<div className="pricing-wrapper">
					<div className="container">
						<h2 className="pricing-wrapper__title">
							White Labelling is available with the Professional and Plus plans
						</h2>

						<button className="btn btn--plans">
							<Link href="/pricing-plans">view plans and pricing</Link>
						</button>
					</div>
				</div>

				<CtaForm />
			</div>
		</Layout>
	);
}
